import { defineMessages } from 'react-intl';

export default defineMessages({
  affirmLogoAlt: {
    id: 'AffirmButton.affirmLogo.alt',
    description: 'Alternative text to Affitm logo',
    defaultMessage: 'Affirm',
  },
});
